import React from 'react';

import monarxShieldYellowUrl from '@/media/gatorProtect/monarx-shield-yellow.png';
import monarxShieldBlueUrl from '@/media/gatorProtect/monarx-shield-blue.png';
import monarxShieldRedUrl from '@/media/gatorProtect/monarx-shield.png';

import * as Styles from './BrandByMonarx.styles';

export type ShieldVariant = 'blue' | 'yellow' | 'red';

const SHIELD_SRC: Record<ShieldVariant, string> = {
  yellow: monarxShieldYellowUrl,
  blue: monarxShieldBlueUrl,
  red: monarxShieldRedUrl,
};

export const GATOR_PROTECT_BRAND_TITLE = 'Gator Protect';
export const GATOR_PROTECT_BRAND_SUBTITLE = 'Powered by Monarx AI';

export type BrandByMonarxProps = {
  shieldVariant: ShieldVariant;
  variant: Styles.ColorVariant;
  showProBadge?: boolean;
  isMobile: boolean;
  className?: string;
  'data-testid'?: string;
};

const BrandByMonarx: React.FC<BrandByMonarxProps> = ({
  shieldVariant,
  variant,
  showProBadge = false,
  isMobile,
  className,
  'data-testid': testId,
}) => {
  const shieldSrc = SHIELD_SRC[shieldVariant];

  return (
    <Styles.Row
      $variant={variant}
      className={className}
      data-testid={testId}
    >
      <Styles.ShieldWrap $isMobile={isMobile}>
        <img src={shieldSrc} alt={GATOR_PROTECT_BRAND_TITLE} />
      </Styles.ShieldWrap>
      <Styles.BrandTextCol>
        <Styles.TopRow>
          <Styles.ProductTitle $isMobile={isMobile} $variant={variant}>
            {GATOR_PROTECT_BRAND_TITLE}
          </Styles.ProductTitle>
          {showProBadge ? <Styles.ProBadge>PRO</Styles.ProBadge> : null}
        </Styles.TopRow>
        <Styles.ProductSubtitle $isMobile={isMobile} $variant={variant}>
          {GATOR_PROTECT_BRAND_SUBTITLE}
        </Styles.ProductSubtitle>
      </Styles.BrandTextCol>
    </Styles.Row>
  );
};

export default BrandByMonarx;
